// extracted by mini-css-extract-plugin
export default {"root":"RescheduleSuccess-module_root_f1fa81","button":"RescheduleSuccess-module_button_b8daf4","text":"RescheduleSuccess-module_text_aa3aec"};